import { render, staticRenderFns } from "./publisDocument.vue?vue&type=template&id=09968844&scoped=true&"
import script from "./publisDocument.vue?vue&type=script&lang=js&"
export * from "./publisDocument.vue?vue&type=script&lang=js&"
import style0 from "./publisDocument.vue?vue&type=style&index=0&id=09968844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09968844",
  null
  
)

export default component.exports